export var sizes = {
  medium: {
    fontSize: 2,
    lineHeight: 2,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 5,
    paddingBottom: '6px'
  }
};
export var _getInputStyles = function _getInputStyles(_ref) {
  var size = _ref.size,
      disabled = _ref.disabled;
  return {
    width: '100%',
    height: '100%',
    background: 'transparent',
    position: 'relative',
    fontSize: sizes[size].fontSize,
    paddingLeft: sizes[size].paddingLeft,
    paddingRight: sizes[size].paddingRight,
    paddingTop: sizes[size].paddingTop,
    paddingBottom: sizes[size].paddingBottom,
    border: 'none',
    outline: 'none',
    color: disabled ? 'grey.400' : 'grey.900',

    /* Remove the default background color in case of autofill*/
    '&:-webkit-autofill,&:-webkit-autofill:hover,&:-webkit-autofill:focus,&:-webkit-autofill:active': {
      '-webkit-box-shadow': "0 0 0 30px white inset !important"
    },
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  };
};